import logoContinente from "@/assets/images/logo-continente.png";

import { ASSETS_BY_KEY, FooterAssetKey } from "@/config/FooterAssetsCatalog";

export function resolveClientTopLogo(logo?: string): string | undefined {
  if (!logo) {
    return logoContinente;
  }

  return logo;
}

/**
 * Logo de um cliente a partir do assetAlias devolvido pelo backend (enum AssetAlias),
 * que espelha o FooterAssetKey. Cai no logo Continente quando o alias e desconhecido.
 */
export function resolveClientAsset(assetAlias?: string): { icon: string; altText?: string } {
  const asset = assetAlias ? ASSETS_BY_KEY[assetAlias as FooterAssetKey] : undefined;

  return asset
    ? { icon: asset.icon, altText: asset.altText }
    : { icon: logoContinente };
}
